export class Arr {
  public static firstOrDefault<T>(array: T[]): T | null {
    return Array.isArray(array) && array.length > 0 ? array[0] : null
  }

  public static lastOrDefault<T>(array: T[]): T | null {
    return Array.isArray(array) && array.length > 0 ? array[array.length - 1] : null
  }

  public static arrayWithSingleElement<T>(array: T[] | undefined | null, value: T): array is [T] {
    return Array.isArray(array) && array.length === 1 && array.includes(value)
  }

  public static isLongerThan(array: unknown[], length: number): boolean {
    return Array.isArray(array) && array.length > length
  }

  public static isLongerOrEqual(array: unknown[], length: number): boolean {
    return Array.isArray(array) && array.length >= length
  }

  public static isShorterThan(array: unknown[], length: number): boolean {
    return Array.isArray(array) && array.length < length
  }

  public static isShorterOrEqual(array: unknown[], length: number): boolean {
    return Array.isArray(array) && array.length <= length
  }

  public static isNullOrEmpty<T>(array: T[] | undefined | null): array is undefined | null | [] {
    return !array || (Array.isArray(array) && array.length === 0)
  }

  public static any<T>(array: T[] | undefined | null): array is [T, ...T[]] {
    return Array.isArray(array) && array.length > 0
  }

  public static isEmpty<T>(array: T[] | undefined | null): array is [] {
    return Array.isArray(array) && array.length === 0
  }

  public static toHashMap<T, U = T>(
    items: T[],
    keySelector: (item: T, index: number) => string | null | undefined,
    valueSelector?: (item: T, index: number) => U
  ) {
    const result: Record<string, U | undefined> = {}
    for (let i = 0; i < items.length; i++) {
      const key = keySelector(items[i], i)
      if (key) {
        result[key] = valueSelector ? valueSelector(items[i], i) : (items[i] as unknown as U)
      }
    }
    return result
  }

  public static sort<T>(
    items: T[],
    sortBy: (item: T) => string | number | Date | undefined,
    direction: 'ASC' | 'DESC' = 'ASC'
  ) {
    const asc = direction === 'ASC' ? -1 : 1
    return items.toSorted((a, b) => {
      const aValue = sortBy(a)
      const bValue = sortBy(b)
      if (aValue == null) {
        return bValue == null ? 0 : -asc
      }
      if (bValue == null) {
        return aValue == null ? 0 : asc
      }
      if (aValue < bValue) {
        return asc
      }
      if (aValue > bValue) {
        return -asc
      }
      return 0
    })
  }
}
